import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'trackify-sign-in-page',
  templateUrl: './sign-in-page.component.html',
  styleUrls: ['./sign-in-page.component.scss']
})
export class SignInPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
